import React, { Component } from "react";
import { connect } from "react-redux";
import { MultiStepModal } from "../multi_step_modals/multi_step_modal";
import get from "lodash/get";
import map from "lodash/map";
import "./audio_block_modal.scss";
import {
  audioBlockCreate,
  audioBlockUpdate,
  getAudioBlock,
  updateMarkers,
} from "../../../action_managers/audio_management";
import { RunBlockSelector } from "./choose_run_block";
import { showWarning } from "../../../actions/app";
import UploadModalActionManager from "../../../action_managers/upload_modal";
import { matchPath, withRouter } from "react-router";
import EditNamePage from "./edit_name";
import BlockEditor from "./block_editor_page";
import { hideModal } from "../../../actions/modal";
import { isDefaultAudioBlock } from "./audio_block_modal_helpers";

class AudioBlockModal extends Component {
  showContent = () => (
    <EditNamePage
      value={this.state.name}
      onChange={e => this.setState({ name: e.target.value })}
      disabled={isDefaultAudioBlock(this.getAudioBlock())}
    />
  );
  UNSAFE_componentWillMount() {
    if (this.props.mode === "edit")
      this.props.getAudioBlock(this.getAudioBlockUUID()).then(resp => {
        if (resp.status === 200) {
          this.setState({
            name: resp.json.name,
            items: resp.json.items.map(({ type, mediaFileUUID }, k) => ({
              id: `item-${k}`,
              type,
              mediaFileUUID,
            })),
            playStyle: resp.json.playStyle,
            limit: resp.json.limit,
          });
        }
      });
  }

  getAudioBlockUUID = () => {
    if (this.props.mode === "create") return undefined;
    var result = matchPath(this.props.location.pathname, "/audio-blocks/:audioBlockUUID");
    return get(result, "params.audioBlockUUID");
  };

  getAudioBlock = () => {
    return get(this.props.audioBlocks, this.getAudioBlockUUID());
  };

  state = {
    items: [],
    playStyle: "inorder",
    toCheck: {},
  };

  blockContent = () => {
    return (
      <BlockEditor
        playStyle={this.state.playStyle}
        onPlaystyleChange={e => {
          this.setState({ playStyle: e.target.value });
        }}
        onLimitChange={e => {
          this.setState({ limit: e.target.value });
        }}
        items={this.state.items}
        onAddAudio={type => {
          this.setState({
            items: [...this.state.items, { type, id: `item-${this.state.items.length}` }],
          });
        }}
        updateItems={items => this.setState({ items })}
        removeItem={this.removeItem}
        onFileLoad={this.onFileLoad}
        limit={this.state.limit}
        disabled={isDefaultAudioBlock(this.getAudioBlock())}
      />
    );
  };

  markerSelect = () => {
    return (
      <RunBlockSelector
        audioBlockUUID={this.getAudioBlockUUID()}
        toCheck={this.state.toCheck}
        updateCheck={toCheck => {
          this.setState({ toCheck });
        }}
      />
    );
  };

  removeItem = (idToRemove, e) => {
    e.stopPropagation();
    const newItems = this.state.items.filter(({ id }) => id !== idToRemove);
    this.setState({ items: newItems });
  };

  onFileLoad = (file, id) => {
    const newItems = this.state.items.map(item => {
      return item.id === id ? { ...item, file } : item;
    });
    this.setState({ items: newItems });
  };

  commonSettings = {
    columns: 8,
    offset: 2,
    showContent: true,
    containerClass: "audio-block-modal",
  };

  shouldDisableName = () => {
    return !get(this.state.name, "length", 0) > 0;
  };
  validateAudioBlocks = () => {
    if (!this.state.items.length) {
      this.props.showWarning("Please populate with at least 1 option");
      return false;
    }

    if (this.state.type === "priority" && !this.state.limit) {
      this.props.showWarning("Please Set a limit");
      return false;
    }

    return this.state.items.every(item => {
      if (item.type === "audioFile" && !(item.file || item.mediaFileUUID)) {
        this.props.showWarning("Please Select a File");
        return false;
      }
      return true;
    });
  };

  pages = () => [
    {
      ...this.commonSettings,
      title: "Audio Block Name",
      shouldDisable: this.shouldDisableName,
      Content: this.showContent(),
    },
    {
      ...this.commonSettings,
      title: "Configure Audio Block",
      closeOnly: this.props.disableNav,
      Content: this.blockContent(),
      validator: this.validateAudioBlocks,
    },
    {
      ...this.commonSettings,
      title: "Assign to Insertion Points",
      Content: this.markerSelect(),
      hideBack: isDefaultAudioBlock(this.getAudioBlock()),
    },
  ];

  handleSubmit = async () => {
    this.setState({ isLoading: true });

    let resp = {};
    try {
      if (!isDefaultAudioBlock(this.getAudioBlock())) {
        const itemWithUploadPromises = this.state.items.map(item => {
          if (!item.file) {
            return item;
          }
          return new Promise((resolve, reject) => {
            this.props.upload(item.file, item.file.name).then(resp => {
              if (resp.status === 200) {
                resolve({ ...item, mediaFileUUID: resp.json[0].uuid });
              } else {
                reject();
              }
            });
          });
        });
        const finalResult = await Promise.all(itemWithUploadPromises);
        if (this.props.mode === "create") {
          resp = await this.props.audioBlockCreate(
            this.state.name,
            this.state.playStyle,
            this.state.limit,
            finalResult
          );
        } else {
          resp = await this.props.audioBlockUpdate(
            this.getAudioBlockUUID(),
            this.state.name,
            this.state.playStyle,
            this.state.limit,
            finalResult
          );
        }
      }
      const audioBlockUUID = this.getAudioBlockUUID() ?? resp.json.uuid;
      const updates = map(this.state.toCheck, (val, markerUUID) => ({
        audioBlockUUID: val ? audioBlockUUID : null,
        uuid: markerUUID,
      }));
      if (updates.length) {
        resp = await this.props.updateMarkers(updates);
      } else {
        this.close();
      }

      if (resp.status === 200) {
        this.close();
      }
    } finally {
      this.setState({ isLoading: false });
    }
  };

  render() {
    return (
      <MultiStepModal
        isLoading={this.state.isLoading}
        startingPage={this.props.startingPage || 0}
        pages={this.pages()}
        close={this.close}
        onSubmit={this.handleSubmit}
      />
    );
  }
  close = () => {
    this.props.closeRoute && this.props.history.push(this.props.closeRoute(this.props.location));
    this.props.closeModal();
  };
}

const mapStateToProps = state => ({
  audioBlocks: state.audioBlocks.audioBlocks,
  markers: state.markers,
});
const mapDispatchToProps = {
  getAudioBlock,
  audioBlockCreate,
  audioBlockUpdate,
  showWarning,
  closeModal: hideModal,
  upload: (file, fileName) => new UploadModalActionManager({ file, fileName }).run(),
  updateMarkers,
};

export const AudioBlockCreateModal = connect(
  state => ({ ...mapStateToProps(state), mode: "create" }),
  mapDispatchToProps
)(withRouter(AudioBlockModal));

export const AudioBlockEditModal = connect(
  state => ({ ...mapStateToProps(state), mode: "edit" }),
  mapDispatchToProps
)(withRouter(AudioBlockModal));
